import React, { useState } from "react";
import Loader from "../Loader/Loader";
import AxiosService from "../../utils/AxiosService";

const reportOptions = [
  { label: "Article was not publicly accessible", value: "not_accessible" },
  { label: "Link did not work", value: "link" },
];

export default function ReportErrorModal({ show, onClose, doi }) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(reportOptions[0].value);
  const [includeEmail, setIncludeEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [resCode, setResCode] = useState(null);

  if (!show) return null;
  const axiosService = new AxiosService();

  function getReportAccessibility(dataObj) {
    setIsLoading(true);
    axiosService
      .getReportAccessibility(dataObj)
      .then((res) => {
        setResCode(res.status);
      })
      .catch((err) => {
        setResCode(err.response?.status || "Network Error");
        console.error("Error ", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const handleSubmit = () => {
    setIsSubmitted(true);
    const dataObj = {
      doi,
      agency: "",
      npa: selectedOption === "not_accessible",
      lnw: selectedOption === "link",
      email,
      comment,
    };
    getReportAccessibility(dataObj);
  };

  const handleClose = () => {
    onClose();
    handleReset();
  };

  const handleReset = () => {
    setResCode(null);
    setSelectedOption(reportOptions[0].value);
    setIncludeEmail(false);
    setEmail("");
    setComment("");
    setIsSubmitted(false);
  };

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div
        className="modal show d-block"
        onClick={() => {
          handleClose();
        }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-top modal-md"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title fs-6">
                Report Accessiblity :{" "}
                <a
                  href={`${doi}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-theme"
                >
                  {doi.replace("https://doi.org/", "")}
                </a>
              </h5>
              <button className="btn-close" onClick={handleClose}></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              {isSubmitted ? (
                isLoading ? (
                  <Loader />
                ) : (
                  <>
                    {resCode === 200 ? (
                      <div className="d-flex flex-column align-items-center gap-3 py-4">
                        Thank you for your input. A member of the CHORUS support
                        staff will look into the issue. If an email address was
                        supplied we may respond with more information.
                      </div>
                    ) : (
                      <div className="d-flex flex-column align-items-center gap-3 py-4 text-danger text-center">
                        Something went wrong while submitting your request.
                        Please try again later.
                      </div>
                    )}
                  </>
                )
              ) : (
                <>
                  {reportOptions.map((option, index) => {
                    return (
                      <div className="form-check mb-2" key={index}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="issue"
                          id={`option-${index}`}
                          value={option.value}
                          checked={option.value === selectedOption}
                          onChange={(e) => setSelectedOption(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`option-${index}`}
                        >
                          {option.label}
                        </label>
                      </div>
                    );
                  })}

                  {/* Checkbox */}
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input custom-checkbox"
                      type="checkbox"
                      id="includeEmail"
                      checked={includeEmail}
                      onChange={(e) => setIncludeEmail(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="includeEmail">
                      Include email address <span className="">*</span>
                    </label>
                  </div>
                  {/* Email Field (shown only if checked) */}
                  {includeEmail && (
                    <div className="mb-3">
                      <label className="form-label">Email:</label>
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  )}

                  {/* Comment */}
                  <div className="mb-2">
                    <label className="form-label">Comment:</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    ></textarea>
                  </div>

                  {/* Privacy Policy */}
                  <small>
                    *{" "}
                    <a
                      href="https://www.chorusaccess.org/privacy-policy/"
                      className="text-decoration-none text-theme"
                      target="_black"
                    >
                      Privacy Policy
                    </a>
                  </small>
                </>
              )}
            </div>
            {/* Footer */}
            {isSubmitted ? (
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleClose}>
                  Close
                </button>
              </div>
            ) : (
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
